import httpManager from "@/app/shared/utils/httpManager";

/**
 * @param {Number} chatbotId
 * @param {Object} body
 */

export async function updateChatbot(chatbotId, body) {
  await httpManager.put(`/chatbots/${chatbotId}/`, body);
}
